/* eslint react-hooks/rules-of-hooks: "off" */
import EnumBase from './Base';
import { useTranslation } from 'react-i18next';

export default function coinsEnum(){
  const { t } = useTranslation();
  const tr = (currency) => t(`currency.${currency}`);
  return new EnumBase([
    {name: tr('brl'), id: 'R$'},
    {name: tr('usd'), id: 'USD'},
    {name: tr('eur'), id: 'EUR'},
    {name: tr('ars'), id: 'ARS'},
  ]);
}
